import React, {useEffect, useLayoutEffect, useRef, useState} from 'react';
import ParlaysAccordion from "../ParlaysAccordion/ParlaysAccordion";

import './UserParlaysContainer.style.scss';
import {FormattedMessage, useIntl} from "react-intl";
import {debounce} from "lodash";
import {useLocation} from "react-router-dom";
import useParlaysAccordionViewModel from "./UserParlaysAccordion.vm";

const EmptyParlaysContainer = ()=>{

    const location = useLocation();
    const isOnLobby = location.pathname.toLowerCase().includes("lobby");

    return  <div className="EmptyParlaysContainer">
        <div className="title">
            <FormattedMessage id={"parlayContainer.title"}/>{isOnLobby ? ".": ","}
        </div>
        {!isOnLobby && <div className="subTitle">
            <FormattedMessage id={"parlayContainer.subTitle"}/>
        </div>}
    </div>;
}

const UserParlaysContainer = ({userParlays, hideNewParlays}) => {
    const vm = useParlaysAccordionViewModel({userParlays, hideNewParlays});

    const [betSlipsContainerHeight, setBetSlipsContainerHeight] = useState(0);
    const headerHeightRef = useRef(0);
    const mainContentMarginTopRef = useRef(0);
    const isEmpty = vm.parlays.length === 0;

    const updateDimensions = debounce(() => {
        const element = document.querySelector('.LobbyView ');
        if (element) {
            const computedStyle = window.getComputedStyle(element);
            mainContentMarginTopRef.current = parseInt(computedStyle.marginTop, 10);
        }

        const headerElement = document.querySelector('.NavigationHeader');
        if (headerElement) {
            headerHeightRef.current = headerElement.offsetHeight;
        }

        const height = window.innerHeight - (headerHeightRef.current + mainContentMarginTopRef.current) - (mainContentMarginTopRef.current / 2);
        setBetSlipsContainerHeight(height);
    }, 300);

    useLayoutEffect(() => {
        updateDimensions();
        window.addEventListener('resize', updateDimensions);
        return () => {
            window.removeEventListener('resize', updateDimensions);
        };
    }, []);

    return (
         <div className={"UserParlaysContainer " + (isEmpty ? "empty" : "")}
             style={{height: betSlipsContainerHeight}}>
            {isEmpty ? <EmptyParlaysContainer/>
                     : <ParlaysAccordion vm={vm}/>
                }
        </div>
    );
}

export default UserParlaysContainer;